import { startOfWeek } from 'date-fns'

/**
 * Get the start of the week (Monday) for a given date
 * Uses date-fns with weekStartsOn: 1 for Monday
 */
export const getWeekStart = (date: Date): Date => {
	return startOfWeek(date, { weekStartsOn: 1 })
}

/**
 * The panel writes every moment on Tashkent's wall clock — the network's business time (the
 * backend's `BUSINESS_TIMEZONE`; all of Uzbekistan is UTC+5) — whatever clock the browser keeps.
 */
export const PANEL_TIME_ZONE = 'Asia/Tashkent'

/** A moment as the server sends it; nothing (or nothing readable) is written `—`. */
export type Moment = Date | string | number | null | undefined

function written(date: Moment, options: Intl.DateTimeFormatOptions): string {
	if (date === null || date === undefined || date === '') return '—'
	const at = new Date(date)
	if (Number.isNaN(at.getTime())) return '—'
	return at.toLocaleString('ru-RU', { timeZone: PANEL_TIME_ZONE, ...options })
}

const DAY = { day: '2-digit', month: '2-digit' } as const
const YEAR = { year: 'numeric' } as const
const TIME = { hour: '2-digit', minute: '2-digit' } as const

/** A time of day: `09:15`. */
export function formatTime(date: Moment): string {
	return written(date, TIME)
}

/**
 * A day-and-time for an operator — the panel's usual way to write a moment of the last weeks
 * (a Box's departure, a discrepancy, a Shift's opening): `25.10, 09:15`.
 */
export function formatDayTime(date: Moment): string {
	return written(date, { ...DAY, ...TIME })
}

/**
 * A day-and-time with its year, where the moment may be older than a year or the year matters
 * (a policy version, a partner key, a Register's payment, a printed label): `25.10.2026, 09:15`.
 */
export function formatDateTime(date: Moment): string {
	return written(date, { ...DAY, ...YEAR, ...TIME })
}

/** A day with its year, no time (a drain's last day, a handover act): `25.10.2026`. */
export function formatDate(date: Moment): string {
	return written(date, { ...DAY, ...YEAR })
}
